/* The Complete / Partial / Not tracked chip on Meals' daily totals. It writes
 * logStatus[date] (keyed by date, so it merges per day with Claude's
 * set_day_status); an absent key leaves the day to logic/energy dayStatus's
 * heuristics. */

export const LOG_STATUS_LABELS = {
  complete: 'Complete',
  partial: 'Partial',
  untracked: 'Not tracked',
  unknown: 'Not logged',
};

const CYCLE = ['complete', 'partial', 'untracked'];

function isObj(v) {
  return !!v && typeof v === 'object' && !Array.isArray(v);
}

/**
 * The status one tap sets. A marked day cycles complete -> partial ->
 * untracked -> complete. An unmarked day's first tap corrects the guess: a
 * day the heuristic calls complete is most likely missing food, one it calls
 * partial (few items, under half the target) most likely was complete after
 * all, and an empty day was not tracked.
 * @param {string|undefined} marked logStatus[date]
 * @param {string} auto dayStatus() of the day
 * @returns {'complete'|'partial'|'untracked'}
 */
export function nextLogStatus(marked, auto) {
  if (CYCLE.includes(marked)) return CYCLE[(CYCLE.indexOf(marked) + 1) % CYCLE.length];
  if (auto === 'complete') return 'partial';
  if (auto === 'partial') return 'complete';
  return 'untracked';
}

/**
 * State with logStatus[date] set, or removed when `status` is null.
 * Returns the same state when nothing changes, so no save is triggered.
 */
export function withLogStatus(state, date, status) {
  const cur = isObj(state.logStatus) ? state.logStatus : {};
  if (!status) {
    if (!Object.prototype.hasOwnProperty.call(cur, date)) return state;
    const next = { ...cur };
    delete next[date];
    return { ...state, logStatus: next };
  }
  if (cur[date] === status) return state;
  return { ...state, logStatus: { ...cur, [date]: status } };
}
